import { useQuery } from 'react-query';

import { getUnmountedHubs } from 'api/InteractiveMap/getUnmountedHubs';

export const useGetUnmountedHubs = (siteSlug: string) => {
  const { data, refetch, isLoading, isRefetching } = useQuery('unmountedHubs', () => getUnmountedHubs(siteSlug), {
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    enabled: !!siteSlug,
  });

  return { data, refetch, isLoading, isRefetching };
};
